import React from 'react'
import useFavurTranslation from 'hooks/useFavurTranslation'
import Headline from 'redesign/components/atoms/Headline'
import Radio from 'redesign/components/atoms/Radio'
import ErrorMessage from 'redesign/components/atoms/error-message'
import { ZERO } from 'shared/constants'
import { Container, Group } from './styles'
import type { RadioFormGroupProps } from './types'

const RadioFormGroup: React.FC<RadioFormGroupProps> = ({
  options = [],
  disabled,
  legend,
  selectedValue,
  setSelectedValue,
  size = 'medium',
  color = 'secondary',
  error,
}) => {
  const { t } = useFavurTranslation()

  return (
    <ErrorMessage hasError={error} errorMessage={t('common.form.error.required', { fieldName: legend })}>
      <Container error={error} disabled={disabled}>
        {legend && <Headline noBottomSpacing text={legend} horizontalSpacing={ZERO} />}
        <Group>
          {options.map((option) => (
            <Radio
              key={option.id}
              size={size}
              error={error}
              color={color}
              value={option.value}
              label={option.label}
              checked={selectedValue === option.value}
              onChange={() => setSelectedValue(option.value)}
            />
          ))}
        </Group>
      </Container>
    </ErrorMessage>
  )
}

export default RadioFormGroup
